import { render, staticRenderFns } from "./AppBody.vue?vue&type=template&id=f73fc9be&scoped=true&"
import script from "./AppBody.vue?vue&type=script&lang=js&"
export * from "./AppBody.vue?vue&type=script&lang=js&"
import style0 from "./AppBody.vue?vue&type=style&index=0&id=f73fc9be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73fc9be",
  null
  
)

export default component.exports